
import {
    defineComponent, PropType,
} from '@vue/composition-api';

import PartialPaymentPopup from '@ve/components/partialPayment/partialPaymentPopup/desktop/PartialPaymentPopup.vue';
import { PartialPaymentTourProduct } from '@ve/components/partialPayment/common/types/PartialPaymentTourProduct';

import usePartialPaymentPopupRef from '@ve/components/partialPayment/common/use/usePartialPaymentPopupRef';
import usePartialPaymentBannerForProductCard from '@ve/components/partialPayment/common/use/usePartialPaymentBannerForProductCard';

export default defineComponent({
    name: 'PartialPaymentBannerForProductCard',
    components: { PartialPaymentPopup },
    props: {
        countryName: {
            type: String,
            default: '',
        },
        products: {
            type: Array as PropType<PartialPaymentTourProduct[]>,
            default: () => ([]),
        },
        productType: {
            type: String as PropType<'hotelOffer' | 'tourOffer'>,
            default: 'tourOffer',
        },
    },
    setup(props) {
        const {
            minPriceText,
            minPercentText,
            productTypeLabelText,
        } = usePartialPaymentBannerForProductCard(props);

        const {
            openPopup,
            partialPaymentPopupRef,
        } = usePartialPaymentPopupRef();

        return {
            minPriceText,
            minPercentText,
            openPopup,
            partialPaymentPopupRef,
            productTypeLabelText,
        };
    },
});
